import Vue from 'vue';

Vue.component('sticky-banner-component', {
    props: {
        bannerData: {
            type: Object,
            required: true,
        },
        storageKey: {
            type: String,
            default: 'sticky_banner_seen',
        },
    },

    data() {
        return {
            isVisible: false,
            currentBannerData: null,
        };
    },

    computed: {
        isCypressRunning() {
            return typeof window !== 'undefined' && window.Cypress;
        },
    },

    mounted() {
        this.removeBannerEntry();
        this.$nextTick(() => {
            this.checkAndShowBanner();
        });
    },

    created() {
        // Different banner content is used for each edition, thus whenever an edition changes sticky banner is
        // displayed again with new content
        EventBus.$on('configurator-set-edition', (edition) => {
            this.removeBannerEntry();
            this.changeContentByEdition(edition.field_commerceHandle);
        });
        EventBus.$on('cyberster-configurator-edition-change', (edition) => {
            this.removeBannerEntry();
            this.changeContentByEdition(edition);
        });
    },

    methods: {
        checkAndShowBanner() {
            if (this.isCypressRunning) {
                console.log('Cypress detected, skipping banner display');
                return;
            }

            if (!this.hasBeenSeen()) {
                this.setInitialBannerData();
                this.showBanner();
            }
        },

        hasBeenSeen() {
            try {
                return localStorage.getItem(this.storageKey) === 'true';
            } catch (e) {
                console.error('Error accessing localStorage:', e);
                return false;
            }
        },

        hideBanner() {
            this.isVisible = false;
            try {
                localStorage.setItem(this.storageKey, 'true');
            } catch (e) {
                console.error('Error writing to localStorage:', e);
            }
        },

        removeBannerEntry() {
            try {
                localStorage.removeItem(this.storageKey);
            } catch (e) {
                console.error('Error clearing localStorage banner data:', e);
            }
        },

        showBanner() {
            this.isVisible = true;
            if (this.isVisible && this.currentBannerData) {
                setTimeout(() => {
                    this.$refs.bannerContainer.classList.add(
                        'sticky-banner__container--open',
                    );
                }, 500);
            }
        },

        setInitialBannerData() {
            const stickyBanner = {
                content: this.bannerData.content[0],
                buttonText: this.bannerData.buttonText,
            };

            this.currentBannerData = stickyBanner;
        },

        changeContentByEdition(editionHandle) {
            let editionBannerContent = this.bannerData.content.find(
                (item) => item.configuratorEditionHandle === editionHandle,
            );

            if (!editionBannerContent) {
                this.hideBanner();
                return;
            }

            this.currentBannerData = {
                content: editionBannerContent,
                buttonText: this.bannerData.buttonText,
            };
            this.showBanner();
        },
    },
});
